module.exports = __webpack_public_path__ + "img/motorcycle-chassi.e2e58c83.png";